import React, { Component } from "react";
import { eventAttendeesService } from "./services/Attendees.service";
import EventsAttendeesTable from "./EventAttendeesTable";

class ManageEventAttendees extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetching: false,
      submitting: false,
      formError: null,
      data: null,
      selectedRow: null,
      hasParams: false,
      error: null,
      pageNum: 0,
      pageSize: 10,
      showModal: false,
      notResetMode: false,
      postId: null,
      eventName: null
    };
  }
  componentDidMount() {
    if (this.props.location.state) {
      const { postId } = this.props.location.state;

      let eventName =
        this.props.location.state.selectedRow &&
        this.props.location.state.selectedRow.title;

      this.setState({ postId: postId, eventName: eventName });

      const { pageNum, pageSize } = this.state;
      this.getEventsAttendees({ id: postId, pageNum: pageNum + 1, pageSize });
    }
  }

  getEventsAttendees = params => {
    this.setState({ fetching: true });
    eventAttendeesService
      .getAllEventsAttendees(params)
      .then(response => {
        response &&
          this.setState({
            data: response,
            pages: Math.ceil(response.count / params.pageSize),
            error: null,
            fetching: false
          });
      })
      .catch(error => this.setState({ error, fetching: false }));
  };

  fetchData = () => {
    const { pageNum, pageSize, filterParams } = this.state;
    let params = { id: this.state.postId, pageNum: pageNum + 1, pageSize };
    if (filterParams) {
      params = { ...filterParams, ...params };
    }
    this.getEventsAttendees(params);
  };

  setPageNumber = pageIndex => {
    this.setState({ pageNum: pageIndex }, () => this.fetchData());
  };

  setPageSize = (pageSize, pageIndex) => {
    this.setState({ pageSize, pageNum: pageIndex }, () => this.fetchData());
  };

  filterData = params => {
    const filterParams = {
      ...this.state.filterParams,
      ...params
    };
    this.setState({ filterParams, pageNum: 0 }, () => this.fetchData());
  };

  selectRow = selectedRow => {
    this.setState({ selectedRow: selectedRow.original, hasParams: true });
  };

  render() {
    const {
      fetching,
      data,
      pages,
      pageNum,
      pageSize,
      error,
      filterParams,
      hasParams,
      selectedRow,
      eventName
    } = this.state;

    return (
      <EventsAttendeesTable
        fetching={fetching}
        hasParams={hasParams}
        selectedRow={selectedRow}
        filterParams={filterParams}
        data={data}
        pages={pages}
        page={pageNum}
        pageSize={pageSize}
        error={error}
        filterData={this.filterData}
        setPageNumber={this.setPageNumber}
        setPageSize={this.setPageSize}
        selectRow={this.selectRow}
        eventName={eventName}
      />
    );
  }
}

export default ManageEventAttendees;
